import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { OTHER_REQUESTS } from "../community/constants";

export default function EditOtherRequestsPage() {
  return <CommunityEditPage section={OTHER_REQUESTS} />;
}
